'use client';

import ErrorMessage from '@/components/common/ErrorMessage';

export default function NotFound() {
  return (
    <ErrorMessage 
      title="404 - Page Not Found"
      message="The page you are looking for might have been removed, had its name changed, or is temporarily unavailable."
      backButtonPath="/"
      backButtonText="Return to Home"
    />
  );
} 